Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.BitmapFilterType = module.exports.default = {
	FULL: "full",
	INNER: "inner",
	OUTER: "outer"
};